// generated from 2_006 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastReceivedSpecificCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_received_specific_campaign_filter"),
  comparison_key: z.enum([
    "6", // 1_051 (52.39%)
    "4", // 773 (38.53%)
    "3", // 134 (6.68%)
    "5", // 48 (2.39%)
  ]),
  display_name: z.object({
    // true 279 (13.91%), false 1_727 (86.09%)
    expired: z.boolean(),
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 743 (37.04%), defined 1_263 (62.96%)
  raw_value: z
    .union([
      // number samples: 1_158 (91.69%)
      // integer: 1_033 (89.21%)
      // avg: 16.24, min: 0, max: 600
      z.number().min(0),
      // string samples: 105 (8.31%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 1_824 (90.93%)
    // integer: 1_611 (88.32%)
    // avg: 17.02, min: 0, max: 600
    z.number().min(0),
    // string samples: 182 (9.07%)
    common.date,
  ]),
  varies_by_app_group: z.literal(true),
});
